import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SpecraDataTable, SpecraMetricStrip } from '@mono/ui-components/captains';
import { SpecraBadge } from '@mono/ui-components/ensigns';
import { SpecraInlineBanner } from '@mono/ui-components/lieutenants';
import { cents, money } from '../ratesView';
export function OverviewTab({ pricing, serverTotal }) {
    const clins = pricing.clinPricing ?? [];
    const active = clins.filter((clin)=>!clin.metadata.removedByAmendment);
    const periods = [
        ...new Set(active.flatMap((clin)=>Object.keys(clin.periodTotals)))
    ];
    const types = [
        ...new Set(clins.map((clin)=>clin.metadata.contractType || 'Generic'))
    ];
    return /*#__PURE__*/ _jsxs("div", {
        className: "space-y-4",
        children: [
            /*#__PURE__*/ _jsx(SpecraMetricStrip, {
                density: "compact",
                metrics: [
                    {
                        id: 'server',
                        label: 'Total contract value · server',
                        value: cents(serverTotal),
                        tone: 'neutral'
                    },
                    {
                        id: 'preview',
                        label: 'Total · preview',
                        value: money(String(active.reduce((sum, clin)=>sum + clin.grandTotal, 0))),
                        tone: 'neutral'
                    },
                    {
                        id: 'clins',
                        label: 'CLINs',
                        value: clins.length,
                        tone: 'neutral'
                    },
                    {
                        id: 'categories',
                        label: 'Labor categories',
                        value: pricing.rateCard?.categories.length ?? 0,
                        tone: 'neutral'
                    },
                    {
                        id: 'tiers',
                        label: 'Shared tiers',
                        value: pricing.sharedTierConfigs?.length ?? 0,
                        tone: 'neutral'
                    }
                ]
            }),
            /*#__PURE__*/ _jsx(SpecraDataTable, {
                rows: periods,
                rowKey: (period)=>period,
                columns: [
                    {
                        id: 'period',
                        header: 'Period',
                        cell: (period)=>period
                    },
                    {
                        id: 'total',
                        header: 'Preview total',
                        cell: (period)=>money(String(active.reduce((sum, clin)=>sum + (clin.periodTotals[period]?.totalCost ?? 0), 0)))
                    }
                ]
            }),
            types.map((type)=>/*#__PURE__*/ _jsxs(SpecraBadge, {
                    children: [
                        type,
                        ":",
                        ' ',
                        clins.filter((clin)=>(clin.metadata.contractType || 'Generic') === type).length
                    ]
                }, type)),
            active.some((clin)=>clin.laborStructure.type !== 'none' && clin.grandTotal === 0) && /*#__PURE__*/ _jsxs(SpecraInlineBanner, {
                tone: "warning",
                children: [
                    "CLINs with no pricing data:",
                    ' ',
                    active.filter((clin)=>clin.laborStructure.type !== 'none' && clin.grandTotal === 0).map((clin)=>clin.clinNumber).join(', ')
                ]
            })
        ]
    });
}
